import { isPlainObject, isArray, each } from "lodash";
export default (function (res) {
    if (res.config.isApolloQuery || res.config.isGraphQuery) {
        return res;
    }
    if (shouldIterate(res.data)) {
        var Etag = getEtagFromResponse(res);
        addEtag(res.data, Etag);
    }
    return res;
});
function addEtag(data, Etag) {
    if (Etag === void 0) { Etag = getEtag(data); }
    if (isArray(data)) {
        each(data, function (item) { return addEtag(item); });
    }
    else if (isPlainObject(data)) {
        data.Etag = Etag;
        each(data, function (item) {
            if (shouldIterate(item))
                addEtag(item);
        });
    }
}
function getEtag(item) {
    return item.etag || item.Etag;
}
function getEtagFromResponse(res) {
    var etag = res.headers.etag;
    var Etag = res.headers.Etag;
    return getEtag(res.data) || etag || Etag;
}
function shouldIterate(obj) {
    return isPlainObject(obj) || Array.isArray(obj);
}
